var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"referral-details__sidebar"},[_c('contact-details',{attrs:{"contact":_vm.contact,"can-edit":_vm.canEdit},on:{"reload-data":_vm.reloadReferral}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }